import { logger } from '@fe/core';
import { GDFFrame } from './gdf/type';
import { WeatherProduct } from './products/products';
import { WeatherProductFileInfo } from './service/types';
import { MessageType, ProductRecordRequest } from './worker/actor/actor-messages';
import { getGlobalDispatcher } from './worker/dispatcher';
import { WeatherStoreProductInfo } from './worker/store/weather-store';

export enum WeatherServerStrategy {
    main1 = 1,
    main2 = 2,
    fixed1 = 4,
    fixed2 = 5
}

export interface WeatherLoaderDummy {
    type: 'dummy';
}

export interface WeatherLoaderFileSource {
    type: 'file';
    directory: FileSystemDirectoryHandle;
}

export interface WeatherLoaderWebSource {
    type: 'web';
    server1: string;
    server2: string;
    requestMethod?: string;
    requestHeaders?: HeadersInit;
    strategy: WeatherServerStrategy;
}

export interface WeatherProductTimestamps {
    timestamp1: number | null;
    timestamp2: number | null;
}

export type WeatherLoaderSource = WeatherLoaderWebSource | WeatherLoaderFileSource | WeatherLoaderDummy;

class _WeatherLoader {
    setSource(info: WeatherLoaderSource) {
        return getGlobalDispatcher().dispatch({ type: MessageType.setLoader, data: info });
    }

    setRecordingDirectory(directory: FileSystemDirectoryHandle | null) {
        return getGlobalDispatcher().dispatch({ type: MessageType.setRecordingDir, data: directory });
    }

    unload(id: number[]) {
        logger.debug('Unloading products %s', id);
        getGlobalDispatcher().dispatch({
            type: MessageType.unloadProduct,
            data: { id }
        });
    }

    unloadAll() {
        getGlobalDispatcher().dispatch({ type: MessageType.unloadAll });
    }

    async record(request: ProductRecordRequest[]) {
        getGlobalDispatcher().dispatch({
            type: MessageType.recordProducts,
            data: request
        });
    }

    async load(product: WeatherProduct, info: WeatherProductFileInfo): Promise<WeatherStoreProductInfo> {
        return await getGlobalDispatcher().dispatch({
            type: MessageType.loadProduct,
            data: {
                product: info,
                accumulate: product.animate // Not sure if this is needed anymore since we have the internal frame record check now
            }
        });
    }

    async getFrame(id: number, frame: number, workspaceId: number): Promise<GDFFrame | null> {
        return await getGlobalDispatcher().dispatch({ type: MessageType.getFrame, data: { id, frame, workspaceId } });
    }
}

export const WeatherLoader = new _WeatherLoader();
